'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ExternalArrow;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function ExternalArrow(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      className: 'icon-svg-external-arrow ' + className,
      width: width,
      height: height,
      viewBox: '0 0 18 18' },
    _react2.default.createElement('path', { d: 'M14.1428571,9.39285714 L14.1428571,12.6071429 C14.1428571,13.4040218 13.8599359,14.0853766 13.2940848,14.6512277 C12.7282338,15.2170787 12.046879,15.5 11.25,15.5 L2.89285714,15.5 C2.09597816,15.5 1.41462336,15.2170787 0.848772321,14.6512277 C0.282921278,14.0853766 0,13.4040218 0,12.6071429 L0,4.25 C0,3.45312102 0.282921278,2.77176622 0.848772321,2.20591518 C1.41462336,1.64006414 2.09597816,1.35714286 2.89285714,1.35714286 L9.96428571,1.35714286 C10.0580362,1.35714286 10.1350443,1.38727648 10.1953125,1.44754464 C10.2555807,1.5078128 10.2857143,1.58482096 10.2857143,1.67857143 L10.2857143,2.32142857 C10.2857143,2.41517904 10.2555807,2.4921872 10.1953125,2.55245536 C10.1350443,2.61272352 10.0580362,2.64285714 9.96428571,2.64285714 L2.89285714,2.64285714 C2.45089065,2.64285714 2.07254622,2.80022164 1.7578125,3.11495536 C1.44307878,3.42968907 1.28571429,3.8080335 1.28571429,4.25 L1.28571429,12.6071429 C1.28571429,13.0491094 1.44307878,13.4274538 1.7578125,13.7421875 C2.07254622,14.0569212 2.45089065,14.2142857 2.89285714,14.2142857 L11.25,14.2142857 C11.6919665,14.2142857 12.0703109,14.0569212 12.3850446,13.7421875 C12.6997784,13.4274538 12.8571429,13.0491094 12.8571429,12.6071429 L12.8571429,9.39285714 C12.8571429,9.29910667 12.8872765,9.22209852 12.9475446,9.16183036 C13.0078128,9.1015622 13.084821,9.07142857 13.1785714,9.07142857 L13.8214286,9.07142857 C13.915179,9.07142857 13.9921872,9.1015622 14.0524554,9.16183036 C14.1127235,9.22209852 14.1428571,9.29910667 14.1428571,9.39285714 Z M18,0.714285714 L18,5.85714286 C18,6.03125087 17.9363846,6.18191901 17.8091518,6.30915179 C17.681919,6.43638456 17.5312509,6.5 17.3571429,6.5 C17.1830348,6.5 17.0323667,6.43638456 16.9051339,6.30915179 L15.1372768,4.54129464 L8.58816964,11.0904018 C8.52120502,11.1573664 8.44419686,11.1908482 8.35714286,11.1908482 C8.27008885,11.1908482 8.19308069,11.1573664 8.12611607,11.0904018 L6.98102679,9.9453125 C6.91406217,9.87834788 6.88058036,9.80133972 6.88058036,9.71428571 C6.88058036,9.62723171 6.91406217,9.55022355 6.98102679,9.48325893 L13.5301339,2.93415179 L11.7622768,1.16629464 C11.635044,1.03906186 11.5714286,0.888393728 11.5714286,0.714285714 C11.5714286,0.540177701 11.635044,0.389509565 11.7622768,0.262276786 C11.8895096,0.135044007 12.0401777,0.0714285714 12.2142857,0.0714285714 L17.3571429,0.0714285714 C17.5312509,0.0714285714 17.681919,0.135044007 17.8091518,0.262276786 C17.9363846,0.389509565 18,0.540177701 18,0.714285714 Z' })
  );
}

ExternalArrow.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/icons/lib/components/ExternalArrow/ExternalArrow.js
// module id = 174
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14